
// export const SITEWEB_SERVER_BASE_URL = "http://192.168.1.18:50000";
// export const SITEWEB_SERVER_BASE_URL = "http://localhost:50000";

export const ADMIN_SERVER_BASE_URL: string = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
  // ? "http://192.168.1.189:1976"
  ? "http://localhost:1976"
  : window.location.origin;

// export const ADMIN_SERVER_BASE_URL: string ="http://localhost:1976";
// export const ADMIN_SERVER_BASE_URL = "http://192.168.1.202:1976"
// export const SITEWEB_SERVER_BASE_URL: string = getServerUrl()


// export const SITEWEB_SERVER_BASE_URL = "http://192.168.1.65:50000";
// export const SITEWEB_SERVER_BASE_URL = "https://demo.spidertechtest.com";
// serverUrl: "http://127.0.0.1:1976",
// serverUrl: "http://192.168.1.60:1976",

export const SITEWEB_SERVER_BASE_URL = "https://spider-ci.com";



// export const SITEWEB_SERVER_BASE_URL = "http://localhost:50000";
// export const SITEWEB_SERVER_BASE_URL: string ="http://192.168.1.165:50000";
// export const ADMIN_SERVER_BASE_URL: string = "http://10.10.10.150:1976";
// export const ADMIN_SERVER_BASE_URL: string = "https://spdtech-admin.loca.lt";

export interface IServerResponse {
  status: number;
  data?: any;
  error?: any;
}

export interface IConfig {
  method: string;
  body: string;
  headers?: IHeaders;
}

export interface IHeaders {
  authorization?: string | undefined;
  Accept: string;
  "Content-Type": string;
}

export async function request<T>(
  url: string,
  route: string,
  config?: any
): Promise<T> {
  const myUrl: string = `${url}${route}`;
  const response = await fetch(myUrl, config);
  return (await response.json()) as T;
}

export const apiClient = {
  /**
   * Effectue un GET vers le serveur et renvoi la réponse en Json
   * {status:number; data?:any; error?: any}
   * @param url   optional
   * @param route obligatoire
   * @returns IServerResponse
   */
  get: (url: string, route: string) =>
    request<IServerResponse>(url, route, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }),

  /**
   * Effectue un POST vers le serveur et renvoi la réponse en Json
   * {status:number; data?:any; error?: any}
   * @param route :string
   * @param payload : object
   * @returns IServerResponses
   */
  post: (url: string, route: string, payload: any) =>
    request<IServerResponse>(url, route, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }),
};
